export default __webpack_public_path__ + "static/media/bg-afternoon.500a4bd5.png";